module.exports = __webpack_public_path__ + "img/20170704_135648_090.ccc39a04.jpg";